export const GET_LOCATION_WISE_FILTERS_SCREEN_DATA_BY_AUDIENCES_REQUEST =
  "GET_LOCATION_WISE_FILTERS_SCREEN_DATA_BY_AUDIENCES_REQUEST";
export const GET_LOCATION_WISE_FILTERS_SCREEN_DATA_BY_AUDIENCES_SUCCESS =
  "GET_LOCATION_WISE_FILTERS_SCREEN_DATA_BY_AUDIENCES_SUCCESS";
export const GET_LOCATION_WISE_FILTERS_SCREEN_DATA_BY_AUDIENCES_ERROR =
  "GET_LOCATION_WISE_FILTERS_SCREEN_DATA_BY_AUDIENCES_ERROR";

export const GET_SCREEN_DATA_BY_AUDIENCES_REQUEST =
  "GET_SCREEN_DATA_BY_AUDIENCES_REQUEST";
export const GET_SCREEN_DATA_BY_AUDIENCES_SUCCESS =
  "GET_SCREEN_DATA_BY_AUDIENCES_SUCCESS";
export const GET_SCREEN_DATA_BY_AUDIENCES_ERROR =
  "GET_SCREEN_DATA_BY_AUDIENCES_ERROR";

export const GET_SCREENS_COST_DATA_REQUEST = "GET_SCREENS_COST_DATA_REQUEST";
export const GET_SCREENS_COST_DATA_SUCCESS = "GET_SCREENS_COST_DATA_SUCCESS";
export const GET_SCREENS_COST_DATA_ERROR = "GET_SCREENS_COST_DATA_ERROR";

export const GET_SCREENS_DATA_ADVANCE_FILTER_REQUEST =
  "GET_SCREENS_DATA_ADVANCE_FILTER_REQUEST";
export const GET_SCREENS_DATA_ADVANCE_FILTER_SUCCESS =
  "GET_SCREENS_DATA_ADVANCE_FILTER_SUCCESS";
export const GET_SCREENS_DATA_ADVANCE_FILTER_ERROR =
  "GET_SCREENS_DATA_ADVANCE_FILTER_ERROR";

export const GET_AUDIENCES_DATA_ADVANCE_FILTER_REQUEST =
  "GET_AUDIENCES_DATA_ADVANCE_FILTER_REQUEST";
export const GET_AUDIENCES_DATA_ADVANCE_FILTER_SUCCESS =
  "GET_AUDIENCES_DATA_ADVANCE_FILTER_SUCCESS";
export const GET_AUDIENCES_DATA_ADVANCE_FILTER_ERROR =
  "GET_AUDIENCES_DATA_ADVANCE_FILTER_ERROR";

export const GET_SCREENS_PRICE_FOR_REGULAR_COHORT_REQUEST =
  "GET_SCREENS_PRICE_FOR_REGULAR_COHORT_REQUEST";
export const GET_SCREENS_PRICE_FOR_REGULAR_COHORT_SUCCESS =
  "GET_SCREENS_PRICE_FOR_REGULAR_COHORT_SUCCESS";
export const GET_SCREENS_PRICE_FOR_REGULAR_COHORT_ERROR =
  "GET_SCREENS_PRICE_FOR_REGULAR_COHORT_ERROR";

export const GET_SCREEN_SUMMARY_DATA_REQUEST =
  "GET_SCREEN_SUMMARY_DATA_REQUEST";
export const GET_SCREEN_SUMMARY_DATA_SUCCESS =
  "GET_SCREEN_SUMMARY_DATA_SUCCESS";
export const GET_SCREEN_SUMMARY_DATA_ERROR = "GET_SCREEN_SUMMARY_DATA_ERROR";

export const GET_SCREEN_SUMMARY_DATA_I_KNOW_IT_ALL_REQUEST =
  "GET_SCREEN_SUMMARY_DATA_I_KNOW_IT_ALL_REQUEST";
export const GET_SCREEN_SUMMARY_DATA_I_KNOW_IT_ALL_SUCCESS =
  "GET_SCREEN_SUMMARY_DATA_I_KNOW_IT_ALL_SUCCESS";
export const GET_SCREEN_SUMMARY_DATA_I_KNOW_IT_ALL_ERROR =
  "GET_SCREEN_SUMMARY_DATA_I_KNOW_IT_ALL_ERROR";

export const GET_SCREEN_SUMMARY_PLAN_TABLE_DATA_REQUEST =
  "GET_SCREEN_SUMMARY_PLAN_TABLE_DATA_REQUEST";
export const GET_SCREEN_SUMMARY_PLAN_TABLE_DATA_SUCCESS =
  "GET_SCREEN_SUMMARY_PLAN_TABLE_DATA_SUCCESS";
export const GET_SCREEN_SUMMARY_PLAN_TABLE_DATA_ERROR =
  "GET_SCREEN_SUMMARY_PLAN_TABLE_DATA_ERROR";
export const GET_SCREEN_SUMMARY_PLAN_TABLE_DATA_RESET =
  "GET_SCREEN_SUMMARY_PLAN_TABLE_DATA_RESET";

export const GET_FINAL_PLAN_PO_DATA_REQUEST = "GET_FINAL_PLAN_PO_DATA_REQUEST";
export const GET_FINAL_PLAN_PO_DATA_SUCCESS = "GET_FINAL_PLAN_PO_DATA_SUCCESS";
export const GET_FINAL_PLAN_PO_DATA_ERROR = "GET_FINAL_PLAN_PO_DATA_ERROR";

export const GET_SCREEN_DATA_CITY_WISE_FOR_UPLOAD_CREATIVES_REQUEST =
  "GET_SCREEN_DATA_CITY_WISE_FOR_UPLOAD_CREATIVES_REQUEST";
export const GET_SCREEN_DATA_CITY_WISE_FOR_UPLOAD_CREATIVES_SUCCESS =
  "GET_SCREEN_DATA_CITY_WISE_FOR_UPLOAD_CREATIVES_SUCCESS";
export const GET_SCREEN_DATA_CITY_WISE_FOR_UPLOAD_CREATIVES_ERROR =
  "GET_SCREEN_DATA_CITY_WISE_FOR_UPLOAD_CREATIVES_ERROR";
export const GET_SCREEN_DATA_CITY_WISE_FOR_UPLOAD_CREATIVES_RESET =
  "GET_SCREEN_DATA_CITY_WISE_FOR_UPLOAD_CREATIVES_RESET";

export const GET_VENDOR_CONFIRMATION_DETAILS_REQUEST =
  "GET_VENDOR_CONFIRMATION_DETAILS_REQUEST";
export const GET_VENDOR_CONFIRMATION_DETAILS_SUCCESS =
  "GET_VENDOR_CONFIRMATION_DETAILS_SUCCESS";
export const GET_VENDOR_CONFIRMATION_DETAILS_ERROR =
  "GET_VENDOR_CONFIRMATION_DETAILS_ERROR";

export const GET_VENDOR_CONFIRMATION_STATUS_TABLE_DETAILS_REQUEST =
  "GET_VENDOR_CONFIRMATION_STATUS_TABLE_DETAILS_REQUEST";
export const GET_VENDOR_CONFIRMATION_STATUS_TABLE_DETAILS_SUCCESS =
  "GET_VENDOR_CONFIRMATION_STATUS_TABLE_DETAILS_SUCCESS";
export const GET_VENDOR_CONFIRMATION_STATUS_TABLE_DETAILS_ERROR =
  "GET_VENDOR_CONFIRMATION_STATUS_TABLE_DETAILS_ERROR";

export const GET_CAMPAIGN_DASHBOARD_DATA_REQUEST =
  "GET_CAMPAIGN_DASHBOARD_DATA_REQUEST";
export const GET_CAMPAIGN_DASHBOARD_DATA_SUCCESS =
  "GET_CAMPAIGN_DASHBOARD_DATA_SUCCESS";
export const GET_CAMPAIGN_DASHBOARD_DATA_ERROR =
  "GET_CAMPAIGN_DASHBOARD_DATA_ERROR";
export const GET_CAMPAIGN_DASHBOARD_DATA_RESET =
  "GET_CAMPAIGN_DASHBOARD_DATA_RESET";

export const GET_TABLE_DATA_FOR_SELECT_TOPICAL_DATA_REQUEST =
  "GET_TABLE_DATA_FOR_SELECT_TOPICAL_DATA_REQUEST";
export const GET_TABLE_DATA_FOR_SELECT_TOPICAL_DATA_SUCCESS =
  "GET_TABLE_DATA_FOR_SELECT_TOPICAL_DATA_SUCCESS";
export const GET_TABLE_DATA_FOR_SELECT_TOPICAL_DATA_ERROR =
  "GET_TABLE_DATA_FOR_SELECT_TOPICAL_DATA_ERROR";

export const PLANNING_PAGE_FOOTER_DATA_REQUEST =
  "PLANNING_PAGE_FOOTER_DATA_REQUEST";
export const PLANNING_PAGE_FOOTER_DATA_SUCCESS =
  "PLANNING_PAGE_FOOTER_DATA_SUCCESS";
export const PLANNING_PAGE_FOOTER_DATA_ERROR =
  "PLANNING_PAGE_FOOTER_DATA_ERROR";

export const GET_TABLE_DATA_SCREEN_WISE_AD_PLAY_REQUEST =
  "GET_TABLE_DATA_SCREEN_WISE_AD_PLAY_REQUEST";
export const GET_TABLE_DATA_SCREEN_WISE_AD_PLAY_SUCCESS =
  "GET_TABLE_DATA_SCREEN_WISE_AD_PLAY_SUCCESS";
export const GET_TABLE_DATA_SCREEN_WISE_AD_PLAY_ERROR =
  "GET_TABLE_DATA_SCREEN_WISET_AD_PLAY_ERROR";

export const GET_TABLE_DATA_FOR_SELECT_TRIGGER_REQUEST =
  "GET_TABLE_DATA_FOR_SELECT_TRIGGER_REQUEST";
export const GET_TABLE_DATA_FOR_SELECT_TRIGGER_SUCCESS =
  "GET_TABLE_DATA_FOR_SELECT_TRIGGER_SUCCESS";
export const GET_TABLE_DATA_FOR_SELECT_TRIGGER_ERROR =
  "GET_TABLE_DATA_FOR_SELECT_TRIGGER_ERROR";

export const TABLE_DATA_SET_AD_PLAY_TIME_REQUEST =
  "TABLE_DATA_SET_AD_PLAY_TIME_REQUEST";
export const TABLE_DATA_SET_AD_PLAY_TIME_SUCCESS =
  "TABLE_DATA_SET_AD_PLAY_TIME_SUCCESS";
export const TABLE_DATA_SET_AD_PLAY_TIME_ERROR =
  "TABLE_DATA_SET_AD_PLAY_TIME_ERROR";

export const GET_ALL_FILTERS_DETAILS_FOR_UPLOAD_CREATIVE_PAGE_REQUEST =
  "GET_ALL_FILTERS_DETAILS_FOR_UPLOAD_CREATIVE_PAGE_REQUEST";
export const GET_ALL_FILTERS_DETAILS_FOR_UPLOAD_CREATIVE_PAGE_SUCCESS =
  "GET_ALL_FILTERS_DETAILS_FOR_UPLOAD_CREATIVE_PAGE_SUCCESS";
export const GET_ALL_FILTERS_DETAILS_FOR_UPLOAD_CREATIVE_PAGE_ERROR =
  "GET_ALL_FILTERS_DETAILS_FOR_UPLOAD_CREATIVE_PAGE_ERROR";
export const GET_ALL_FILTERS_DETAILS_FOR_UPLOAD_CREATIVE_PAGE_RESET =
  "GET_ALL_FILTERS_DETAILS_FOR_UPLOAD_CREATIVE_PAGE_RESET";

export const GET_CREATIVES_FROM_CREATIVE_BUCKET_FOR_UPLOAD_REQUEST =
  "GET_CREATIVES_FROM_CREATIVE_BUCKET_FOR_UPLOAD_REQUEST";
export const GET_CREATIVES_FROM_CREATIVE_BUCKET_FOR_UPLOAD_SUCCESS =
  "GET_CREATIVES_FROM_CREATIVE_BUCKET_FOR_UPLOAD_SUCCESS";
export const GET_CREATIVES_FROM_CREATIVE_BUCKET_FOR_UPLOAD_ERROR =
  "GET_CREATIVES_FROM_CREATIVE_BUCKET_FOR_UPLOAD_ERROR";
export const GET_CREATIVES_FROM_CREATIVE_BUCKET_FOR_UPLOAD_RESET =
  "GET_CREATIVES_FROM_CREATIVE_BUCKET_FOR_UPLOAD_RESET";

export const GET_ALL_PLANNER_IDS_AND_EMAIL_REQUEST =
  "GET_ALL_PLANNER_IDS_AND_EMAIL_REQUEST";
export const GET_ALL_PLANNER_IDS_AND_EMAIL_SUCCESS =
  "GET_ALL_PLANNER_IDS_AND_EMAIL_SUCCESS";
export const GET_ALL_PLANNER_IDS_AND_EMAIL_ERROR =
  "GET_ALL_PLANNER_IDS_AND_EMAIL_ERROR";
export const GET_ALL_PLANNER_IDS_AND_EMAIL_RESET =
  "GET_ALL_PLANNER_IDS_AND_EMAIL_RESET";

export const GET_BASIC_DETAILS_COST_SUMMARY_REQUEST =
  "GET_BASIC_DETAILS_COST_SUMMARY_REQUEST";
export const GET_BASIC_DETAILS_COST_SUMMARY_SUCCESS =
  "GET_BASIC_DETAILS_COST_SUMMARY_SUCCESS";
export const GET_BASIC_DETAILS_COST_SUMMARY_ERROR =
  "GET_BASIC_DETAILS_COST_SUMMARY_ERROR";
export const GET_BASIC_DETAILS_COST_SUMMARY_RESET =
  "GET_BASIC_DETAILS_COST_SUMMARY_RESET";

export const GET_CLIENT_COST_FOR_COST_SUMMARY_REQUEST =
  "GET_CLIENT_COST_FOR_COST_SUMMARY_REQUEST";
export const GET_CLIENT_COST_FOR_COST_SUMMARY_SUCCESS =
  "GET_CLIENT_COST_FOR_COST_SUMMARY_SUCCESS";
export const GET_CLIENT_COST_FOR_COST_SUMMARY_ERROR =
  "GET_CLIENT_COST_FOR_COST_SUMMARY_ERROR";
export const GET_CLIENT_COST_FOR_COST_SUMMARY_RESET =
  "GET_CLIENT_COST_FOR_COST_SUMMARY_RESET";

export const GET_VENDOR_PAYOUT_FOR_COST_SUMMARY_REQUEST =
  "GET_VENDOR_PAYOUT_FOR_COST_SUMMARY_REQUEST";
export const GET_VENDOR_PAYOUT_FOR_COST_SUMMARY_SUCCESS =
  "GET_VENDOR_PAYOUT_FOR_COST_SUMMARY_SUCCESS";
export const GET_VENDOR_PAYOUT_FOR_COST_SUMMARY_ERROR =
  "GET_VENDOR_PAYOUT_FOR_COST_SUMMARY_ERROR";
export const GET_VENDOR_PAYOUT_FOR_COST_SUMMARY_RESET =
  "GET_VENDOR_PAYOUT_FOR_COST_SUMMARY_RESET";

export const GET_GROSS_MARGIN_FOR_COST_SUMMARY_REQUEST =
  "GET_GROSS_MARGIN_FOR_COST_SUMMARY_REQUEST";
export const GET_GROSS_MARGIN_FOR_COST_SUMMARY_SUCCESS =
  "GET_GROSS_MARGIN_FOR_COST_SUMMARY_SUCCESS";
export const GET_GROSS_MARGIN_FOR_COST_SUMMARY_ERROR =
  "GET_GROSS_MARGIN_FOR_COST_SUMMARY_ERROR";
export const GET_GROSS_MARGIN_FOR_COST_SUMMARY_RESET =
  "GET_GROSS_MARGIN_FOR_COST_SUMMARY_RESET";

export const GET_INVENTORY_DETAILS_FOR_COST_SUMMARY_REQUEST =
  "GET_INVENTORY_DETAILS_FOR_COST_SUMMARY_REQUEST";
export const GET_INVENTORY_DETAILS_FOR_COST_SUMMARY_SUCCESS =
  "GET_INVENTORY_DETAILS_FOR_COST_SUMMARY_SUCCESS";
export const GET_INVENTORY_DETAILS_FOR_COST_SUMMARY_ERROR =
  "GET_INVENTORY_DETAILS_FOR_COST_SUMMARY_ERROR";
export const GET_INVENTORY_DETAILS_FOR_COST_SUMMARY_RESET =
  "GET_INVENTORY_DETAILS_FOR_COST_SUMMARY_RESET";

export const EDIT_COST_DETAILS_SCREEN_WISE_FOR_COST_SUMMARY_REQUEST =
  "EDIT_COST_DETAILS_SCREEN_WISE_FOR_COST_SUMMARY_REQUEST";
export const EDIT_COST_DETAILS_SCREEN_WISE_FOR_COST_SUMMARY_SUCCESS =
  "EDIT_COST_DETAILS_SCREEN_WISE_FOR_COST_SUMMARY_SUCCESS";
export const EDIT_COST_DETAILS_SCREEN_WISE_FOR_COST_SUMMARY_ERROR =
  "EDIT_COST_DETAILS_SCREEN_WISE_FOR_COST_SUMMARY_ERROR";
export const EDIT_COST_DETAILS_SCREEN_WISE_FOR_COST_SUMMARY_RESET =
  "EDIT_COST_DETAILS_SCREEN_WISE_FOR_COST_SUMMARY_RESET";

export const SEND_BUDGET_APPROVAL_TO_VENDOR_COST_SUMMARY_REQUEST =
  "SEND_BUDGET_APPROVAL_TO_VENDOR_COST_SUMMARY_REQUEST";
export const SEND_BUDGET_APPROVAL_TO_VENDOR_COST_SUMMARY_SUCCESS =
  "SEND_BUDGET_APPROVAL_TO_VENDOR_COST_SUMMARY_SUCCESS";
export const SEND_BUDGET_APPROVAL_TO_VENDOR_COST_SUMMARY_ERROR =
  "SEND_BUDGET_APPROVAL_TO_VENDOR_COST_SUMMARY_ERROR";
export const SEND_BUDGET_APPROVAL_TO_VENDOR_COST_SUMMARY_RESET =
  "SEND_BUDGET_APPROVAL_TO_VENDOR_COST_SUMMARY_RESET";

export const SEND_BUDGET_APPROVAL_TO_VENDOR_CREATIVE_APPROVAL_REQUEST =
  "SEND_BUDGET_APPROVAL_TO_VENDOR_CREATIVE_APPROVAL_REQUEST";
export const SEND_BUDGET_APPROVAL_TO_VENDOR_CREATIVE_APPROVAL_SUCCESS =
  "SEND_BUDGET_APPROVAL_TO_VENDOR_CREATIVE_APPROVAL_SUCCESS";
export const SEND_BUDGET_APPROVAL_TO_VENDOR_CREATIVE_APPROVAL_ERROR =
  "SEND_BUDGET_APPROVAL_TO_VENDOR_CREATIVE_APPROVAL_ERROR";
export const SEND_BUDGET_APPROVAL_TO_VENDOR_CREATIVE_APPROVAL_RESET =
  "SEND_BUDGET_APPROVAL_TO_VENDOR_CREATIVE_APPROVAL_RESET";

export const SEND_CAMPAIGN_STATUS_REPORT_TO_CLIENT_REQUEST =
  "SEND_CAMPAIGN_STATUS_REPORT_TO_CLIENT_REQUEST";
export const SEND_CAMPAIGN_STATUS_REPORT_TO_CLIENT_SUCCESS =
  "SEND_CAMPAIGN_STATUS_REPORT_TO_CLIENT_SUCCESS";
export const SEND_CAMPAIGN_STATUS_REPORT_TO_CLIENT_ERROR =
  "SEND_CAMPAIGN_STATUS_REPORT_TO_CLIENT_ERROR";
export const SEND_CAMPAIGN_STATUS_REPORT_TO_CLIENT_RESET =
  "SEND_CAMPAIGN_STATUS_REPORT_TO_CLIENT_RESET";

export const SEND_CAMPAIGN_FINAL_CONFIRMATION_REQUEST =
  "SEND_CAMPAIGN_FINAL_CONFIRMATION_REQUEST";
export const SEND_CAMPAIGN_FINAL_CONFIRMATION_SUCCESS =
  "SEND_CAMPAIGN_FINAL_CONFIRMATION_SUCCESS";
export const SEND_CAMPAIGN_FINAL_CONFIRMATION_ERROR =
  "SEND_CAMPAIGN_FINAL_CONFIRMATION_ERROR";
export const SEND_CAMPAIGN_FINAL_CONFIRMATION_RESET =
  "SEND_CAMPAIGN_FINAL_CONFIRMATION_RESET";
